var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoDesignWorkNeeded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 159.41 159.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-linecap:square;}.cls-1,.cls-2{fill:rgba(255,255,255,.2);}.cls-1,.cls-2,.cls-3{stroke:#fff;stroke-miterlimit:10;}.cls-3{fill:#1e83f7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M152.4,137.72c5.02-11.22-8.1-33.83,.6-46.41,.49-.73,1.06-1.41,1.72-2.07,.35-.71,.54-1.52,.54-2.36,0-.96-.25-1.85-.67-2.63,2.43-.81,4.11-2.54,4.11-4.57s-1.68-3.76-4.11-4.57c.42-.78,.67-1.67,.67-2.62,0-.84-.19-1.65-.54-2.36-.65-.65-1.21-1.33-1.71-2.04-8.73-12.58,4.42-35.21-.61-46.44,1.73,.33,3.58-.17,4.91-1.5,2.14-2.14,2.14-5.59,0-7.73-.67-.67-1.47-1.13-2.32-1.38,1.15-2.3,1.11-4.72-.32-6.14-.06-.06-.12-.11-.18-.17-1.43-1.44-3.85-1.47-6.14-.32-.25-.85-.7-1.65-1.38-2.32-2.14-2.14-5.59-2.14-7.73,0-1.33,1.33-1.83,3.18-1.5,4.91-11.23-5.03-33.86,8.12-46.44-.61-.71-.5-1.39-1.06-2.04-1.71-.71-.35-1.52-.54-2.36-.54-.95,0-1.84,.25-2.62,.67-.81-2.43-2.55-4.11-4.57-4.11s-3.76,1.68-4.57,4.11c-.78-.42-1.67-.67-2.63-.67-.84,0-1.65,.19-2.36,.54-.66,.66-1.34,1.23-2.07,1.72-12.58,8.7-35.19-4.42-46.41,.6,.33-1.73-.17-3.58-1.51-4.91C18.04-.03,14.58-.03,12.44,2.1c-.67,.67-1.13,1.47-1.37,2.32-2.3-1.15-4.72-1.11-6.15,.32-.06,.06-.11,.12-.17,.18-1.44,1.43-1.47,3.85-.32,6.14-.85,.25-1.65,.7-2.32,1.38C-.03,14.59-.03,18.05,2.1,20.18c1.33,1.33,3.18,1.83,4.91,1.5-5.03,11.23,8.12,33.86-.61,46.44-.5,.71-1.06,1.39-1.71,2.04-.35,.71-.54,1.52-.54,2.36,0,.95,.25,1.84,.67,2.62-2.43,.81-4.11,2.55-4.11,4.57s1.68,3.76,4.11,4.57c-.42,.78-.67,1.67-.67,2.63,0,.84,.19,1.65,.54,2.36,.66,.66,1.23,1.34,1.72,2.07,8.7,12.58-4.42,35.19,.6,46.41-1.73-.33-3.58,.17-4.91,1.51-2.14,2.13-2.14,5.59,0,7.73,.67,.67,1.47,1.13,2.32,1.37-1.15,2.3-1.11,4.72,.32,6.15,.03,.03,.06,.05,.09,.08,.03,.03,.05,.06,.08,.09,1.43,1.44,3.86,1.47,6.15,.32,.24,.85,.7,1.65,1.37,2.32,2.14,2.14,5.6,2.14,7.73,0,1.34-1.33,1.84-3.18,1.51-4.91,11.22,5.02,33.83-8.1,46.41,.6,.73,.49,1.41,1.06,2.07,1.72,.71,.35,1.52,.54,2.36,.54,.96,0,1.85-.25,2.63-.67,.81,2.43,2.54,4.11,4.57,4.11s3.76-1.68,4.57-4.11c.78,.42,1.67,.67,2.62,.67,.84,0,1.65-.19,2.36-.54,.65-.65,1.33-1.21,2.04-1.71,12.58-8.73,35.21,4.42,46.44-.61-.33,1.73,.17,3.58,1.5,4.91,2.14,2.14,5.59,2.14,7.73,0,.67-.67,1.13-1.47,1.38-2.32,2.3,1.15,4.72,1.11,6.14-.32,.04-.04,.06-.06,.09-.1,.03-.03,.06-.05,.1-.09,1.44-1.43,1.47-3.86,.32-6.15,.85-.24,1.65-.7,2.32-1.37,2.14-2.14,2.14-5.6,0-7.73-1.33-1.34-3.18-1.84-4.91-1.51Zm-20.53-5.45H27.53V27.14h104.34v105.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 88.34,
    y: 84.11,
    width: 30.49,
    height: 30.49
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 88.27,
    y1: 84.11,
    x2: 118.83,
    y2: 114.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 118.83,
    y1: 84.11,
    x2: 88.27,
    y2: 114.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 41.44,
    y: 42.25,
    width: 77.39,
    height: 30.49
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 41.44,
    y1: 42.25,
    x2: 118.83,
    y2: 72.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 118.83,
    y1: 42.25,
    x2: 41.44,
    y2: 72.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 75.09,
    y1: 84.11,
    x2: 41.44,
    y2: 84.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 75.09,
    y1: 87.93,
    x2: 41.44,
    y2: 87.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 75.09,
    y1: 91.74,
    x2: 41.44,
    y2: 91.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 75.09,
    y1: 95.55,
    x2: 41.44,
    y2: 95.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 75.09,
    y1: 99.36,
    x2: 41.44,
    y2: 99.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 75.09,
    y1: 103.17,
    x2: 41.44,
    y2: 103.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 75.09,
    y1: 106.98,
    x2: 41.44,
    y2: 106.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 75.09,
    y1: 110.79,
    x2: 41.44,
    y2: 110.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 75.09,
    y1: 114.61,
    x2: 41.44,
    y2: 114.61
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDesignWorkNeeded);
export default __webpack_public_path__ + "static/media/no-design-work-needed.552b2f0254dcc548f5c546618501a3ba.svg";
export { ForwardRef as ReactComponent };